export default "__VITE_ASSET__D09AyJYv__"